if (window.AlmeaFavorites) {
  // Module already initialized — avoid double click listeners
} else {

const STORAGE_KEY = 'almea:favorites';
const EVENT_NAME = 'almea:favorites:change';

function read() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (_) {
    return [];
  }
}

function write(list) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch (_) {}
  document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { list } }));
}

function has(handle) {
  return read().some((entry) => entry.handle === handle);
}

function add(handle, id) {
  const list = read();
  if (list.some((entry) => entry.handle === handle)) return list;
  list.push({ handle, id: id ? String(id) : null, addedAt: Date.now() });
  write(list);
  return list;
}

function remove(handle) {
  const list = read().filter((entry) => entry.handle !== handle);
  write(list);
  return list;
}

function toggle(handle, id) {
  return has(handle) ? remove(handle) : add(handle, id);
}

function syncToggleButtons() {
  const list = read();
  const handles = new Set(list.map((entry) => entry.handle));
  document.querySelectorAll('[data-favorite-toggle]').forEach((btn) => {
    const handle = btn.getAttribute('data-product-handle');
    const active = handle && handles.has(handle);
    btn.classList.toggle('is-active', !!active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Retirer des favoris' : 'Ajouter aux favoris');
  });
}

function syncCounters() {
  const count = read().length;
  document.querySelectorAll('[data-favorites-count]').forEach((el) => {
    el.textContent = count > 99 ? '99+' : String(count);
    el.classList.toggle('is-empty', count === 0);
  });
}

function handleClick(event) {
  const btn = event.target.closest('[data-favorite-toggle]');
  if (!btn) return;
  event.preventDefault();
  event.stopPropagation();
  const handle = btn.getAttribute('data-product-handle');
  const id = btn.getAttribute('data-product-id');
  if (!handle) return;
  toggle(handle, id);
}

function init() {
  syncToggleButtons();
  syncCounters();
  document.addEventListener('click', handleClick, true);
  document.addEventListener(EVENT_NAME, () => {
    syncToggleButtons();
    syncCounters();
  });
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) {
      syncToggleButtons();
      syncCounters();
    }
  });
  window.addEventListener('pageshow', () => {
    syncToggleButtons();
    syncCounters();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

window.AlmeaFavorites = { read, add, remove, toggle, has };

}
